import { makeStyles, styled, useTheme } from '@mui/styles';

const useStyles = makeStyles((props) => {
    return {
    gridHeader: {
        color:  ({ color }) => color,   //  || (theme.palette.mode === 'dark' ? "white" : "black")
        background: ({ backGroundColor }) => backGroundColor,
        fontSize: ({ fontSize }) => fontSize || '14px',
        fontFamily: "Times New Roman', Times, serif",
        textAlign: 'left !important',
    },

    gridHeaderBorder: {
        color: ({ color }) => color,
        background: ({ backGroundColor }) => backGroundColor,
        fontSize: ({ fontSize }) => fontSize || '14px',
        fontFamily: "Times New Roman', Times, serif",
        textAlign: 'center'
    },

    seachButton: {
        border: 'none',
        borderRadius: '10px',
        padding: '5px 10px',
        backgroundColor: 'white',
        color: 'green',
        cursor: 'pointer',
        marginRight: '20px',
        width: "70px"
    },
    editSearchButton: {
        border: 'none',
        borderRadius: '10%',
        padding: '2px 2px',
        backgroundColor: 'green',
        color: 'white',
        cursor: 'pointer',
        marginRight: '20px'
    },
    senhaButton: {
        border: 'none',
        borderRadius: '10px',
        padding: '5px 10px',
        backgroundColor: 'red',
        color: 'white',
        cursor: 'pointer',
        marginRight: '20px'
    },
    promotionSearchButton: {
        border: 'none',
        borderRadius: '10px',
        padding: '5px 10px',
        backgroundColor: 'darkblue',
        color: 'white',
        cursor: 'pointer',
        marginRight: '20px',
        fontSize: "10px"
    },
    
    deleteSearchButton: {
        color: 'red',
        cursor: 'pointer'
    },
    statementSearchButton: {
        border: 'none',
        borderRadius: '10px',
        padding: '5px 10px',
        backgroundColor: 'yellow',
        color: 'black',
        cursor: 'pointer',
        marginRight: '20px'
    },
    imageContainer: {
        width: '100px',
        height: '80px',
        borderRadius: '10px',
        objectFit: 'fill',
        display: 'flex',
        alignContent: 'center',
        marginTop: '-10px'
    },
    imageList: {
        width: '40px',
        height: '35px',
        borderRadius: '40px',
        objectFit: 'fill',
        display: 'flex',
        alignContent: 'center',

    },
    inputStyle: {
        background: props.backGroundColor || 'white',
        minWidth: '15%',
        width: ({ width }) => width || '65%',
        color: ({ color }) => color,
        height: ({ height }) => height || '30px',
        paddingBottom: '0',
        borderRadius: '10px',
        objectFit: 'cover',
        fontWeight: 'bold',
        marginTop: '4px',
        marginLeft: ({ marginLeft }) => marginLeft || '0px'
    },
    textAreaStyle: {
        // background: props.backGroundColor || "white",
        //  color: props.color || "blak",
        width: ({ width }) => width || '65%',
        paddingBottom: '0',
        borderRadius: '10px',
        objectFit: 'cover',
        fontWeight: 'bold',
        marginTop: '4px',
        marginLeft: ({ marginLeft }) => marginLeft || '0px',
        marginTop: ({ marginTop }) => marginTop || '0px'
    },
    pageHeader: {
        color: ({ color }) => color || 'white',
        background: ({ backGroundColor }) => backGroundColor || 'darkBlue',
        marginTop: '4px',
        marginLeft: '4px',
        marginRight: '4px',
        width: '100%'
    },
    balanceStyle: {
        color: 'black',
        background: 'yellow',
        fontSize: '12px',
        fontFamily: "Times New Roman', Times, serif",
        //  textAlign: 'left',
        width: '100%',
       // height: '100%',
        display: 'flex',
        alignItems: 'center',
        

    },
    radioButton: {
        fontSize: '10px',
        fontFamily: "Times New Roman', Times, serif",
        display: 'flex',
        alignContent: 'center'
    },

    selectStyle: {
        minWidth: '15%',
        width: ({ width }) => width || '65%',
        height: ({ height }) => height || '40px',
        borderRadius: '10px',
        objectFit: 'cover',
        fontWeight: 'bold'
    },

    sideBarmainContenair: {
        //flex: 1,
        height: '160hv',
        background: 'rgb(15, 15, 66)', // "rgb(15, 15, 66)", props.backGroundColor ||
        position: 'sticky',
        top: '0px',
        left: '0',
        transition: '350ms',
        textAlign: 'left',
        width: ({ width1 }) => width1,
        // width: width1,
        // width: "40px",
        position: 'relative'
    },
    ButtonStatutDataGrid_actif: {
        padding: '5px 7px',
        border: 'none',
        borderRadius: '30px',
        width: '100%',
        fontSize: "10px",
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'lightblue',
        fontWeight: 600
    },
    ButtonStatutDataGrid_inactif: {
        padding: '5px 7px',
        border: 'none',
        borderRadius: '30px',
        width: '80px',
        display: 'flex',
        width: '100%',
        fontSize: "10px",
        justifyContent: 'center',
        backgroundColor: 'rgb(250, 188, 188)',
        fontWeight: 600
    },
    ButtonStatutDataGrid_pendent: {
        padding: '5px 7px',
        border: 'none',
        borderRadius: '30px',
        width: '80px',
        display: 'flex',
        width: '100%',
        fontSize: "10px",
        justifyContent: 'center',
        backgroundColor: 'rgb(152, 138, 236)',
        fontWeight: 600
    },
    ButtonStatutDataGrid_deleted: {
        padding: '5px 7px',
        border: 'none',
        borderRadius: '30px',
        width: '80px',
        display: 'flex',
        width: '100%',
        fontSize: "10px",
        justifyContent: 'center',
        backgroundColor: 'black',
        color: 'white',
        fontWeight: 600,
        textDecoration: 'line-through'
    },
    tipoMovimentoReclamacoesLandingPage: {
        color: 'black',
        background: 'darkgrey',
        fontSize: '10px',
        fontFamily: "Times New Roman', Times, serif",
        textAlign: 'center',
        width: '200%',
        height: '85%'
    },
    tipoMovimentoAvaliacoesLandingPage: {
        color: 'black',
        background: 'lightblue',
        fontSize: '10px',
        fontFamily: "Times New Roman', Times, serif",
        textAlign: 'center',
        width: '200%',
        height: '85%'
    },
    tipoMovimentoSugestoesLandingPage: {
        color: 'black',
        background: 'lightcyan',
        fontSize: '10px',
        fontFamily: "Times New Roman', Times, serif",
        textAlign: 'center',
        width: '200%',
        height: '85%'
    },

    tipoMovimentoReclamacoesLandingPageColorLeve: {
        color: 'black',
        background: '#f8f6f2',
        fontSize: '10px',
        fontFamily: "Times New Roman', Times, serif",
        textAlign: 'center',
        width: '200%',
        height: '85%'
    },
    recoursStyle: {
        color: 'black',
        background: 'yellow',
        fontSize: '13px',
        fontFamily: "Times New Roman', Times, serif",
        textAlign: 'center',
        width: '100%',
        height: '85%'
    },

    coursPasEtudiantCouleur: {
        color: 'white',
        background: 'red',
        fontSize: '13px',
        fontFamily: "Times New Roman', Times, serif",
        textAlign: 'left',
        width: '100%',
        height: '85%'
    },

    coursPasEtudiantRepeteCouleur: {
        color: 'white',
        background: 'green',
        fontSize: '13px',
        fontFamily: "Times New Roman', Times, serif",
        textAlign: 'left',
        width: '100%',
        height: '85%'
    },

    coursPasEtudiantOptionManquant: {
        color: 'white',
        background: 'orange',
        fontSize: '13px',
        fontFamily: "Times New Roman', Times, serif",
        textAlign: 'left',
        width: '100%',
        height: '85%'
    },

    deuxiemeSessionStyle: {
        color: 'white',
        background: 'lightgreen',
        fontSize: '13px',
        fontFamily: "Times New Roman', Times, serif",
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center', // Vertically center
        justifyContent: 'center', // Horizontally center
        width: '100%',
        height: '100%',
        boxSizing: 'border-box', // Ensures padding and border are included in the total width and height
    },
    recoursNonPayeStyle: {
        color: 'white',
        background: 'red',
        fontSize: '12px',
        fontFamily: "Times New Roman', Times, serif",
        textAlign: 'left',
        width: '100%',
        height: '85%'
    },
    recoursPayeStyle: {
        color: 'green',
        background: 'green',
        fontSize: '12px',
        fontFamily: "Times New Roman', Times, serif",
        textAlign: 'left',
        width: '100%',
        height: '85%'
    },

    iconPagamento: {
        width: '60px',
        height: '60px',
        alignContent: 'center',
    },

    typeInscription: {
        color: 'white',
        background: 'red',
        fontSize: '12px',
        fontFamily: "Times New Roman', Times, serif",
        textAlign: 'left',
        width: '100%',
        height: '85%'
    },

    multaDesactivadatyle: {
        color: 'white',
        background: 'black',
        fontSize: '12px',
        fontFamily: "Times New Roman', Times, serif",
        //  textAlign: 'left',
        width: '100%',
       // height: '100%',
        display: 'flex',
        alignItems: 'center',
    },

    afectsrCursoButton: {
        border: 'none',
        borderRadius: '10%',
        padding: '2px 2px',
        backgroundColor: 'blue',
        color: 'white',
        cursor: 'pointer',
        marginRight: '20px'
    },
    }
});



export default useStyles;
